import template from './thankYou.html';
import './thankYou.scss';

export const CheckoutThankYouModule =
    angular.module('app.components.checkout.components.checkoutThankYou', []).component('checkoutThankYou', {
        template,
        bindings: {
            onExitCheckout: '&',
            user: '<'
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/checkout/components/thankYou/thankYou.js